import { createAction, props } from "@ngrx/store";

export const fetchAffiliate = createAction(
  "[Affiliate] Fetch Affiliate",
  props<{ filterOptions }>()
);

export const fetchAffiliateSuccess = createAction(
  "[Affiliate] Fetch Affiliate Success",
  props<{ affiliate }>()
);

export const fetchAffiliateFailure = createAction(
  "[Affiliate] Fetch Affiliate Faild",
  props<{ error }>()
);

export const getAffiliate = createAction(
  "[Affiliate] Get Affiliate",
  props<{ id }>()
);

export const getAffiliateSuccess = createAction(
  "[Affiliate] Get Affiliate Success",
  props<{ affiliate }>()
);

export const getAffiliateFailure = createAction(
  "[Affiliate] Get Affiliate Failure",
  props<{ error }>()
);



